
import React, { Component } from 'react';
import './student-bulk-import.scss'
import { Modal, ModalBody } from "reactstrap";
import { ImageConstants, Constants } from '../../../constants/constants';
import { getImageSource } from '../../../utility/image-source'
import CommonUtils from '../../../utility/common-utilities';
import ExcelToJson from '../../common/excel-to-json/excel-to-json';
import SchoolUserApi from '../../../apis/student'
import CommonApi from '../../../apis/common'
class StudentBulkImport extends Component {

    state = {
        type: this.props.type,
        classDetails: this.props.selectedClass,
        renderUploadModal: true,
        duplicateStudents: {},
        uploadedStudents: [],
        uploadedCount: 0,
        viewDuplicate: true,
        classes: [],
        ingnoreStatus: {},
    }
    ignoredCount = 0

    orderedClass = ["ALL","Class 1", "Class 2","Class 3","Class 4","Class 5", "Class 6", "Class 7", "Class 8", "Class 9", "Class 10", "Class 11", "Class 12"]
    componentDidMount() {
        this.getCountryCodes()
    }

    getCountryCodes(payload = {}) {
        CommonApi.getCountryCodeList(payload)
            .then(response => {
                let data = response.response
                if (data.length) {
                    this.buildCountryCodeHash(data)
                }
            })
            .catch(err => { })
    }

    buildCountryCodeHash(list = []) {
        let countryCodeHash = {}
        for (let i = 0; i < list.length; i++) {
            let item = list[i]
            countryCodeHash[item.dialCode] = item
        }
        this.setState({ hashedCountryCode: countryCodeHash })
    }

    onSave() {

        this.setState({ isSubmit: true })

        let backupUsers = {}, totalUsers = 0
        let payload = {
            class: this.state?.classDetails?.class,
            board: this.state?.classDetails?.board,
            section: this.state?.classDetails?.section,
            sectionId: this.state?.classDetails?._id,
            isAllowDuplicate: !this.state.renderUploadModal,
            uploadType: this.props.type
        }
        if (this.state.renderUploadModal) {
            if (!this.validateStudentPayload(this.state.students, payload)) return
            payload.students = this.state.students
        } else {

            let students = []
            let usersByClass = this.state.duplicateStudents[this.state.selectedClass]
            for (let key in usersByClass) {
                if (key == 'total') continue
                let usersByReson = usersByClass[key]

                for (let i = 0; i < usersByReson.length; i++) {
                    let user = usersByReson[i]
                    if (user?.action === "UPLOAD") {
                        students.push(user.copy)
                    } else if (!user.action) {
                        totalUsers += 1
                        if (backupUsers[key]) {
                            backupUsers[key].push(user)
                        } else {
                            backupUsers[key] = [user]
                        }
                    } else {
                        this.ignoredCount += 1
                    }
                }
            }

            payload.students = students

        }

        let currentClassDetail = {}
        let overAllUsers = {}

        let newClassSelected = ""
        if (!totalUsers) {
            for (let i = 0; i < this.orderedClass.length; i++) {
                if (this.state.selectedClass !== this.orderedClass[i] && this.state.duplicateStudents[this.orderedClass[i]]) {
                    if (!newClassSelected) newClassSelected = this.orderedClass[i]
                    overAllUsers[this.orderedClass[i]] = this.state.duplicateStudents[this.orderedClass[i]]
                }
            }
        } else if (!this.state.renderUploadModal) {
            currentClassDetail = {
                total: totalUsers,
                ...backupUsers
            }
            overAllUsers = this.state.duplicateStudents
            overAllUsers[this.state.selectedClass] = currentClassDetail
        }


        let classDetail = Object.keys(overAllUsers)

        if (!this.state.renderUploadModal && !classDetail.length && !payload.students.length) {
            this.props.onSave(this.state.uploadedCount || 0)
            return
        }

        if (classDetail.length && !this.state.renderUploadModal) {
            let upadteObj = { duplicateStudents: overAllUsers, }
            if (newClassSelected) upadteObj.selectedClass = newClassSelected
            this.setState(upadteObj)
        }

        this.setState({ isSaving: true })

        SchoolUserApi.addBulkSchoolUser(payload).then(response => {
            let data = response.data
            let uploadedCount = this.state.uploadedCount + data.uploadedUser.length
            let uploadedStudents = [...data.uploadedUser, ...this.state.uploadedStudents]
            if (data.duplicateUser?.length) {
                let groupByClass = this.prepareDublicateUsersPayload(data.duplicateUser || [])
                let classes = Object.keys(groupByClass)
                this.setState({
                    duplicateStudents: classDetail.length ? overAllUsers : groupByClass,
                    renderUploadModal: false,
                    uploadedStudents: uploadedStudents,
                    uploadedCount: uploadedCount,
                    isSubmit: false,
                    isSaving: false,
                    classes,
                    selectedClass: classes[0]
                })
                return
            }
            if ((!classDetail.length && !this.state.renderUploadModal) || (this.state.renderUploadModal && !data.duplicateUser?.length)) this.props.onSave(uploadedCount)
            this.setState({ isSubmit: false, isSaving: false, uploadedStudents: uploadedStudents, duplicateStudents: overAllUsers })
        }).catch(err => {
            this.setState({ isSubmit: false, isSaving: false })
        })
    }

    prepareDublicateUsersPayload(dublicateUsers) {
        if (!dublicateUsers.length) {
            return {}
        }
        let classBasedUsers = {}
        for (let i = 0; i < dublicateUsers.length; i++) {
            let user = dublicateUsers[i]
            let uploadUser = user.copy

            let className = uploadUser.class || "ALL"
            let reason = user.original.reason
            if (classBasedUsers[className]) {
                classBasedUsers[className].total += 1
                if (classBasedUsers[className][reason]) {
                    classBasedUsers[className][reason].push(dublicateUsers[i])
                } else {
                    classBasedUsers[className][reason] = [dublicateUsers[i]]
                }
            } else {
                classBasedUsers[className] = { [reason]: [dublicateUsers[i]], total: 1 }
            }
        }

        let orderObj = {}
        for (let i = 0; i < this.orderedClass.length; i++) {
            if (classBasedUsers[this.orderedClass[i]]) {
                orderObj[this.orderedClass[i]] = classBasedUsers[this.orderedClass[i]]
            }
        }
        return orderObj
    }

    validateStudentPayload(students = [], payload) {


        if (this.state.type != "CLASS_FROM_EXCEL") {
            if (!payload.board) {
                this.setState({ errorMessage: `please select board` })
                return false
            }

            if (!payload.class) {
                this.setState({ errorMessage: `please select class` })
                return false
            }

        }

        if (!students.length) {
            this.setState({ errorMessage: `please select valid excel file` })
            return false
        }

        let dublicateFromExcel = [], studentHash = {}

        for (let i = 0; i < students.length; i++) {
            let student = students[i]
            let key = `${student.name}_${student.contactNumber}_${student.contactEmail}_${student.type}`

            if (this.state.type === "CLASS_FROM_EXCEL") {
                if (!student.board) {
                    this.setState({ errorMessage: `please select valid board in line no: ${i + 2}` })
                    return false
                }
                if (!student.class) {
                    this.setState({ errorMessage: `please select valid class in line no: ${i + 2}` })
                    return false
                }

                if (!student.type) {
                    this.setState({ errorMessage: `please select valid type in line no: ${i + 2}` })
                    return false
                }

                key = `${key}_${student.board}_${student.class}`
            } else {
                let studentKeys = Object.keys(student)
                console.log(student)
                if (studentKeys.includes("board") || studentKeys.includes("class")) {
                    this.setState({ errorMessage: `The template is mismatched, Please check the format` })
                    return false
                }
                // if (student.board && this.state.classDetails?.board != student.board) {
                //     this.setState({ errorMessage: `We don't allow different board in this option. if you want to upload this excel file please go to students menu` })
                //     return false
                // }

                // if (student.class && this.state.classDetails?.class != student.class) {
                //     this.setState({ errorMessage: `We don't allow different class in this option. if you want to upload this excel file please go to students menu` })
                //     return false
                // }
            }

            if (!student.name) {
                this.setState({ errorMessage: `please enter student name in line no: ${i + 2}` })
                return false
            }

            if (!student.contactNumber && !student.contactEmail) {
                this.setState({ errorMessage: `Please add Contact number or email in line no: ${i + 2}` })
                return false
            }

            if (student.contactNumber && !student.countryCode) {
                this.setState({ errorMessage: `Please add country code in line no: ${i + 2}` })
                return false
            }

            if (student.contactEmail && !this.validateEmail(student.contactEmail)) {
                this.setState({ errorMessage: `please enter student contact email in line no: ${i + 2}` })
                return false
            }

            if (student.countryCode && student.contactNumber) {
                const countryCodeDetail = this.state.hashedCountryCode[student.countryCode]

                if (!countryCodeDetail) {
                    this.setState({ errorMessage: `please enter correct country code in line no: ${i + 2}` })
                    return false
                }
                const validateCountryCode = CommonUtils.validateMobileNumber(
                    student.contactNumber,
                    countryCodeDetail
                )
                if (!validateCountryCode) {
                    this.setState({ errorMessage: `please enter valid mobile number in line no: ${i + 2}` })
                    return false
                }
            }



            if (!student.rollNumber) {
                this.setState({ errorMessage: `please enter student role number in line no: ${i + 2}` })
                return false
            }

            if (!student.gender) {
                this.setState({ errorMessage: `please enter student gender in line no: ${i + 2}` })
                return false
            }

            if (studentHash[key]) {
                dublicateFromExcel.push(`[${[studentHash[key]]}=${i + 2}]`)
            } else {
                studentHash[key] = i + 2
            }
        }

        if (dublicateFromExcel.length) {
            this.setState({ errorMessage: `There are some duplicate entry in your excel line no: ${dublicateFromExcel.join(" ")}` })
            return false
        }

        return true
    }

    validateEmail(value) {
        if (value) {
            let isValid = CommonUtils.validateEmail(value);
            if (!isValid) {
                this.setState({ isInvalidEmail: true });
                return false
            }
            else {
                this.setState({ isInvalidEmail: false })
                return true
            }
        } else {
            this.setState({ isInvalidEmail: true });
            return false
        }
    }


    onSuccessUploadExcel = (res) => {
        console.log(res.data)
        if (res.data) {
            let students = this.extractFromExcel(res.data)
            // console.log(students)
            // console.log(res.fileName)
            this.setState({
                excelFileName: res?.fileName || "",
                students
            })
            return
        }

        if (res.error) {
            this.setState({ errorMessage: "Excel upload error" })
        }
    }

    extractFromExcel(data) {
        console.log(data)
        let studentsList = []

        for (let i = 0; i < data.length; i++) {
            let obj = data[i]
            // console.log(obj)
            let student = {
                name: obj["Name"].trim(),
                contactNumber: obj["Contact Number"].trim(),
                contactEmail: obj["Contact Email"].trim(),
                countryCode: obj["Country Code"],
                rollNumber: obj["Roll Number"] ? obj["Roll Number"].trim() : "",
                previousYearMarks: obj["Previous Year Mark"].trim(),
            }

            if(obj['Secondary Contact Number']) {
                student.secondaryContactNumber = obj['Secondary Contact Number'].trim()
            }


            if (obj["Type"]) {
                student.type = obj["Type"].trim()
            }

            if (obj["Gender"]) {
                student.gender =
                    obj['Gender'].trim() === 'Male'
                        ? 'M'
                        : obj['Gender'].trim() === 'Female'
                            ? 'F'
                            : ''
            }

            if (obj["Class"]) {
                student.class = obj["Class"].trim()
            }

            if (obj["Board"]) {
                student.board = obj["Board"].trim()
            }

            // if(obj['City']) {
            //     student.city = obj['City'].trim()
            // }
            // if(obj['State']) {
            //     student.state = obj['State'].trim()
            // }
            // if(obj['Country']) {
            //     student.country = obj['Country'].trim()
            // }
            // if(obj['Passcode']) {
            //     student.passcode = obj['Passcode'].trim()
            // }
            if (obj['Section']) {
                student.section = obj['Section'].trim()
            }

            console.log(student)

            studentsList.push(student)
        }

        return studentsList
    }

    removeExcelFile() {
        this.setState({ excelFileName: "", students: [] })
    }

    onClickIgnore(item, index, action, key) {
        item.action = item.action === action ? "" : action
        let duplicateStudents = this.state.duplicateStudents
        duplicateStudents[this.state.selectedClass][key][index] = item
        this.setState({ duplicateStudents })
    }

    ignoreOrUploadAll(action, key) {

        let status = action
        let ingnoreStatus = this.state.ingnoreStatus
        if (ingnoreStatus[this.state.selectedClass] && ingnoreStatus[this.state.selectedClass][key] == action) status = ""

        let students = this.state.duplicateStudents[this.state.selectedClass]

        let arr = students[key]
        arr.forEach(element => {
            element.action = status
        });

        let duplicateStudents = this.state.duplicateStudents
        duplicateStudents[this.state.selectedClass][key] = arr

        if (ingnoreStatus[this.state.selectedClass]) {
            ingnoreStatus[this.state.selectedClass][key] = status
        } else {
            ingnoreStatus[this.state.selectedClass] = { [key]: status }
        }

        this.setState({ duplicateStudents, status })
    }

    changeToUploadedList = () => {
        let viewDuplicate = !this.state.viewDuplicate
        this.setState({ viewDuplicate })
    }

    onClickTab(value) {
        this.setState({ selectedClass: value })
    }

    showExcelFormat = () => {
        const link = document.createElement('a');
        link.href = this.state.type != "CLASS_FROM_EXCEL" ? Constants.STUDENT_EXCEL_FORMAT_1 : Constants.STUDENT_EXCEL_FORMAT_3
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    renderDuplicateTable(duplicateStudents) {
        let arr = []
        for (let key in duplicateStudents) {
            if (key === "total") continue
            let students = duplicateStudents[key]
            arr.push(
                <div className="pt-4">
                    <div className="row">
                        <div className="col-6">Duplicate Reason: <strong>{key}</strong></div>
                        <div className="col-6 text-right">
                            <span className="mr-2"><img alt="" className="icon-20 mr-2" src={getImageSource(ImageConstants.GREEN_TICK_V1)} /> Existing Entry </span>
                            <span><img alt="" className="icon-20 mr-2" src={getImageSource(ImageConstants.INFO_RED_FILL)} /> Duplicate Entry </span>
                        </div>
                    </div>
                    <div id="scroll-1" className="max-div">
                        <div id="table-scoll" className="table-responsive mt-2">
                            <table className="table cw-table">
                                <thead>
                                    <tr>
                                        <th className='th-left-radius'></th>
                                        <th>Name</th>
                                        <th>Email</th>
                                        <th>Phone</th>
                                        <th>Section</th>
                                        <th className='pl-4' onClick={() => this.ignoreOrUploadAll("IGNORE", key)} ><img alt="" className="icon-20 mr-2" src={getImageSource(students.every(item => item.action == "IGNORE") ? ImageConstants.RECT_TICK : ImageConstants.RECT)} />Ignore All</th>
                                        <th className='th-right-radius pl-4' onClick={() => this.ignoreOrUploadAll("UPLOAD", key)} ><img alt="" className="icon-20 mr-2" src={getImageSource(students.every(item => item.action == "UPLOAD") ? ImageConstants.RECT_TICK : ImageConstants.RECT)} />Upload All</th>
                                    </tr>
                                </thead>
                                <tbody className="bg-white">
                                    {
                                        students.length ? students.map((item, index) => (
                                            <>
                                                {
                                                    item.original.data?.length ? item.original.data.map((element, i) => (
                                                        <tr className="mt-4 tr-border">
                                                            <td className="max-30"><img className="icon-20 mr-2" src={getImageSource(ImageConstants.GREEN_TICK_V1)} /></td>
                                                            <td>{element?.name}</td>
                                                            <td>{element?.email}</td>
                                                            <td>{element?.countryCode}-{element?.mobileNumber}</td>
                                                            <td className="border-right">{element?.section}</td>
                                                            {i === 0 ? <td className="cursor-pointer pl-4" rowSpan={`${(item.original.data?.length || 0) + 1}`} onClick={() => this.onClickIgnore(item, index, "IGNORE", key)}><img alt="" className="icon-20 mr-2" src={getImageSource(item.action === "IGNORE" ? ImageConstants.RECT_TICK : ImageConstants.RECT_BLACK)} />Ignore</td> : ""}
                                                            {i === 0 ? <td className="cursor-pointer pl-4" rowSpan={`${(item.original.data?.length || 0) + 1}`} onClick={() => this.onClickIgnore(item, index, "UPLOAD", key)}><img alt="" className="icon-20 mr-2" src={getImageSource(item.action === "UPLOAD" ? ImageConstants.RECT_TICK : ImageConstants.RECT_BLACK)} />Upload</td> : ""}
                                                        </tr>
                                                    ))
                                                        :
                                                        ""
                                                }
                                                <tr className="copy tr-border">
                                                    <td className="max-30"><img className="icon-20 mr-2" src={getImageSource(ImageConstants.INFO_RED_FILL)} /></td>
                                                    <td>{item?.copy?.name}</td>
                                                    <td>{item?.copy?.contactEmail}</td>
                                                    <td>{item.copy?.countryCode}-{item.copy?.contactNumber}</td>
                                                    <td className="border-right">{this.state?.classDetails?.section}</td>
                                                </tr>
                                            </>
                                        ))
                                            : <tr className="bg-white pt-4"><td colSpan="11" align='center'>No Records found</td></tr>
                                    }
                                </tbody>
                            </table>
                        </div >
                    </div >
                </div >
            )
        }
        return arr
    }

    renderUploadSuccessModal() {
        const students = this.state.duplicateStudents[this.state.selectedClass]
        let dublicateStudentsCount = Math.abs((this.state.students?.length || 0) - ((this.state.uploadedStudents?.length || 0) + this.ignoredCount))
        let classes = Object.keys(this.state.duplicateStudents)
        return (
            <Modal className="cw-custom-modal student-upload-success" isOpen={true} toggle={this.props.onClose} size={this.props.size || 'md'}>

                <ModalBody >

                    <div className="row">
                        <div className="col">
                            <img alt="" className="close-icon cursor-pointer" onClick={this.props.onClose} src={getImageSource(ImageConstants.CROSS)} />
                        </div>
                    </div>

                    <div className="student-bulk-import">
                        <div className="border-bottom">
                            {
                                this.state.viewDuplicate ?
                                    <span className="duplicate py-2 pl-2 pr-5 text-danger ">
                                        <img alt="" src={getImageSource(ImageConstants.INFO_RED)} /> Out of {this.state.students?.length || 0} Students, {this.state.uploadedStudents?.length || 0} Uploaded successfully, {this.ignoredCount ? <span> {this.ignoredCount} ignored, </span> : ""} <b> {dublicateStudentsCount || 0} Pending due to duplicate match</b>
                                    </span> :
                                    <span><strong>{this.state.uploadedStudents?.length || 0} Students Uploaded successfully</strong></span>
                            }

                            <span className="float-right text-primary mt-2">
                                {
                                    this.state.viewDuplicate ?
                                        <span className="text-primary cursor-pointer" onClick={this.changeToUploadedList}>View {this.state.uploadedStudents?.length || 0} Uploaded students</span>
                                        :
                                        <span className="text-danger cursor-pointer" onClick={this.changeToUploadedList}>
                                            View {dublicateStudentsCount || 0} Students Duplicated
                                        </span>
                                }
                            </span>
                        </div>
                        <div>
                            {
                                this.state.viewDuplicate ?
                                    <div className="pt-4">
                                        <div className="row">
                                            <div className="col-8">
                                                {classes.map(item => <span className={`class-tab px-2 mr-4 cursor-pointer  ${item === "ALL" ? "display-none" : ""} ${item === this.state.selectedClass ? "active-class" : ""}`} onClick={() => this.onClickTab(item)}>{item} ( {this.state.duplicateStudents[item]?.total || 0} )</span>)}
                                            </div>

                                            <div className="col text-right">
                                                <span className="cw-btn-primary cursor-pointer px-5 py-2" onClick={() => this.onSave()}>
                                                    Submit
                                                </span>
                                            </div>

                                        </div>
                                        <div className="mt-4">
                                            {this.renderDuplicateTable(students)}
                                        </div>
                                    </div>
                                    :
                                    <div id="scroll-1 max-div">
                                        <div id="table-scoll" className="table-responsive mt-4">
                                            <table className="table cw-table">
                                                <thead>
                                                    <tr>
                                                        <th className='th-left-radius'>Name</th>
                                                        <th>Section</th>
                                                        <th>Email</th>
                                                        <th className='th-right-radius'>Phone</th>
                                                    </tr>
                                                </thead>
                                                <tbody className="bg-white">
                                                    {
                                                        this.state.uploadedStudents?.length ? this.state.uploadedStudents.map((item, index) => (
                                                            <>
                                                                <tr className="mt-4 tr-border border-bottom">
                                                                    <td>{item?.name}</td>
                                                                    <td>{this.state?.classDetails?.section || "-"}</td>
                                                                    <td>{item?.contactEmail}</td>
                                                                    <td>{item?.countryCode}-{item?.contactNumber}</td>
                                                                </tr>
                                                            </>
                                                        ))
                                                            : <tr className="bg-white pt-4 border-bottom"><td colSpan="3" align='center'>No Records found</td></tr>
                                                    }
                                                </tbody>
                                            </table>
                                        </div >
                                    </div>
                            }
                        </div>
                    </div>
                </ModalBody>
            </Modal >
        );
    }

    renderUploadModal() {

        console.log(this.state.excelFileName)

        return (
            <Modal className="cw-custom-modal" isOpen={true} toggle={this.props.onClose} size={this.props.size || 'md'}>
                <ModalBody >
                    <div className="row">
                        <div className="col">
                            <img className="close-icon cursor-pointer" onClick={this.props.onClose} src={getImageSource(ImageConstants.CROSS)} />
                        </div>
                    </div>

                    <div className="student-bulk-import">

                        <div className="header-text text-center">
                            <span>ADD STUDENTS</span>
                        </div>

                        <div className='bw-spaces-input py-5'>
                            <div className="import-excel-div ">
                                <label className="py-2 px-4 m-0">
                                    {this.state?.excelFileName || ""}
                                </label>
                                {
                                    this.state.excelFileName ?
                                        <label className="excel float-right text-danger py-2 px-4 m-0" onClick={() => this.removeExcelFile()}>
                                            REMOVE EXCEL
                                        </label>
                                        :
                                        <label className="excel float-right text-success py-2 px-4 m-0">
                                            <ExcelToJson onSuccess={this.onSuccessUploadExcel} />
                                            ADD EXCEL
                                        </label>}
                            </div>
                            <div className="text-right pt-1">
                                <span className='check-text' onClick={this.showExcelFormat}>
                                    <img
                                        alt=""
                                        className='export-xls'
                                        src={getImageSource(ImageConstants.XLS_BLUE)}
                                    />
                                    Check Format Here
                                </span>
                            </div>
                        </div>

                        <div className="text-center">
                            {this.state.errorMessage ? <div className="text-danger pb-4 px-4"><strong>{this.state.errorMessage} </strong></div> : ""}
                            <button className="cw-button-primary" onClick={() => this.onSave()}>
                                Save
                            </button>
                        </div>
                    </div>
                </ModalBody>

            </Modal >
        );
    }

    render() {



        if (this.state.renderUploadModal) return this.renderUploadModal()
        else return this.renderUploadSuccessModal()
    }
}

export default StudentBulkImport;